__turbopack_context__.v({
  "loaderContainer": "F5KzzG_loaderContainer",
  "overlayLoader": "F5KzzG_overlayLoader",
  "overlayLoaderContainer": "F5KzzG_overlayLoaderContainer",
});
